<template>
    <div>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="bdname" fixed min-width="200">
                <template slot-scope="scope">
                    <template v-if="scope.row.by3==='1'">
                        <el-button type="text" @click="detailHandler(scope.row.bdcode)">{{scope.row.bdname}}</el-button>
                    </template>
                    <template v-else>
                        {{scope.row.bdname}}
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="标段编码" prop="bdcode" min-width="240"></el-table-column>

            <el-table-column label="操作" width="500" fixed="right">
                <template slot-scope="scope">
                    <my-btn
                    v-if="scope.row.by3==='1'"
                    type="detail"
                    @click="detailHandler(scope.row.bdcode)">
                        查看
                    </my-btn>

                    <my-btn
                    v-else
                    type="edit"
                    @click="editHandler(scope.row.bdcode)">
                        审查
                    </my-btn>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('bidUrl')}/Zbdl/zgsc/xingtai/get_list.json`">
        </my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [ LIST_PAGE_MIXIN ],
    components: {},
    data() {
        return {
            pgData: {
                sortname: 'bdcode',
                zbprocode: this.getQuery('zbprocode')
            },

            model: {}
        }
    },
    computed: {

    },
    methods: {
        gotoForm(url) {
            this.goto({
                path: url,
                query: this.getQuery()
            })
        },
        detailHandler(bdcode) {
             this.goto({
                path:'./detail',
                query:{
                    bdcode:bdcode,
                  
                }
            });    
        },
        editHandler(bdcode) {
             this.goto({
                path:'./form',
                query:{
                    bdcode:bdcode,
                }
            });    
        }


    },
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/Zbdl/zgsc/xingtai/list.json`, {
            zbprocode: this.getQuery('zbprocode')
        }, data => {

        });
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
</style>
